/** In endpoint manage/products/licenses/SerialNumber 
Type - 0 (NotActivated)
Type - 1(Activated)
Type - 2 (cancelled)
*/

export const ALL_ACTIVATED_STATUS = "0,1,2";

export type ActivatedStatus = "notactivated" | "activated" | "cancelled" | string;

const activatedStatusLookup: {
  [key: number]: "Not Activated" | "Activated" | "Cancelled";
} = {
  0: "Not Activated",
  1: "Activated",
  2: "Cancelled",
};

export const activatedStatusIdToName = (id: number) => {
  return activatedStatusLookup[id];
};
